import { Card, CardContent, CardHeader } from "@components/common/card"
import { cn } from "@pma/utils/helpers"

export function SkeletonChart({ className }: { className?: string }) {
  return (
    <Card className={cn("animate-pulse border border-gray-100 shadow-sm", className)}>
      <CardHeader className='pb-2'>
        <div className='h-4 w-40 rounded bg-gray-200' />
        <div className='mt-1 h-3 w-56 rounded bg-gray-200' />
      </CardHeader>
      <CardContent className='flex h-[280px] items-center justify-center'>
        <div className='h-40 w-40 rounded-full border-[24px] border-gray-100 bg-gray-200' />
      </CardContent>
    </Card>
  )
}

export function SkeletonTable() {
  return (
    <Card className='animate-pulse border border-gray-100 shadow-sm'>
      <CardHeader className='pb-2'>
        <div className='h-4 w-48 rounded bg-gray-200' />
      </CardHeader>
      <CardContent>
        <div className='space-y-3'>
          {[...Array(5)].map((_, i) => (
            <div key={i} className='flex items-center gap-4'>
              <div className='h-4 w-32 rounded bg-gray-200' />
              <div className='h-4 w-16 rounded bg-gray-200' />
              <div className='h-4 w-16 rounded bg-gray-200' />
              <div className='h-2 flex-1 rounded bg-gray-200' />
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
